import { Controller } from '@hotwired/stimulus';

/**
 * OTP Submit Spinner Controller
 *
 * Shows a loading spinner and hides the OTP inputs when the
 * parent form is submitted. Provides visual feedback during
 * the verification round-trip.
 */
export default class extends Controller {
  static targets = ['spinner', 'resend'];

  connect() {
    this.form = this.element.closest('form');
    if (this.form) {
      this.handleSubmitBound = this.handleSubmit.bind(this);
      this.form.addEventListener('submit', this.handleSubmitBound);
    }
  }

  disconnect() {
    if (this.form) {
      this.form.removeEventListener('submit', this.handleSubmitBound);
    }
  }

  handleSubmit() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove('hidden');
    }
    if (this.hasResendTarget) {
      this.resendTarget.classList.add('hidden');
    }
  }
}
